import styled from "styled-components";
import {motion} from "framer-motion";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {focusRing} from "../../../Styles/media";

const Holder = styled.div<{ $size: 'sm' | 'md', $fullWidth: boolean }>`
    display: ${({$fullWidth}) => ($fullWidth ? 'flex' : 'inline-flex')};
    align-items: stretch;
    flex-shrink: 0;
    width: ${({$fullWidth}) => ($fullWidth ? '100%' : 'auto')};
    height: ${({$size}) => ($size === 'sm' ? '34px' : '44px')};
    border: 1px solid ${({theme}) => theme.lineStrong};
    border-radius: ${({theme}) => theme.radius.sm};
    background-color: rgba(255, 255, 255, 0.03);
    overflow: hidden;
    transition: border-color 220ms ${({theme}) => theme.ease.out};

    &:hover {
        border-color: ${({theme}) => theme.accentLine};
    }
`

const StepButton = styled.button`
    ${focusRing};
    display: flex;
    align-items: center;
    justify-content: center;
    width: 42px;
    flex-shrink: 0;
    color: ${({theme}) => theme.colorMuted};
    transition: background-color 200ms ${({theme}) => theme.ease.out},
    color 200ms ${({theme}) => theme.ease.out};

    &:hover:not(:disabled) {
        background-color: ${({theme}) => theme.accent};
        color: ${({theme}) => theme.accentContrast};
    }

    &:disabled {
        color: ${({theme}) => theme.colorFaint};
        cursor: not-allowed;
    }
`

const StepIcon = styled(FontAwesomeIcon)`
    width: 11px;
    height: 11px;
`

/**
 * The readout takes the leftover width so the two controls sit at the ends and
 * the number stays optically centred — the stepper then reads as one control
 * whether it is inline or stretched to a card's full width.
 */
const Value = styled.span`
    position: relative;
    display: flex;
    flex: 1;
    align-items: center;
    justify-content: center;
    gap: 4px;
    min-width: 46px;
    padding: 0 6px;
    border-left: 1px solid ${({theme}) => theme.line};
    border-right: 1px solid ${({theme}) => theme.line};
    background-color: rgba(255, 255, 255, 0.03);
    user-select: none;
`

const ValueNumber = styled(motion.span)`
    font-size: 14px;
    font-weight: 700;
    font-variant-numeric: tabular-nums;
    line-height: 1;
    color: ${({theme}) => theme.color};
`

const ValueUnit = styled.span`
    font-size: 11px;
    font-weight: 600;
    letter-spacing: 0.04em;
    color: ${({theme}) => theme.colorFaint};
`

export const Styled = {
    Holder,
    StepButton,
    StepIcon,
    Value,
    ValueNumber,
    ValueUnit
}
